module.exports = __webpack_public_path__ + "static/thumbnail_canva_flat-0ee3779be8130c343f1dc5d1d7da5471.jpg";